import { useContext, useEffect } from "react";
import { RenderContext } from "../../Component/RenderComponent/RenderComponent";
import { useNavigate } from "react-router-dom";

export const Home = () => {
  const user: any = useContext(RenderContext);
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/UserList");
  }, [user]);

  return (
    <h1 style={{ fontFamily: "inherit" }}>{`Welcome To Chitkara University Admin Panel ${user?.name}`}</h1>
  );
};